import { z } from "zod";
import { zIdName } from "src/types/ZIdName";
import { zUid } from "src/types/zUid";
import { zDisplayId } from "src/types/ZDisplayId";

// Группы/Роли для левого края таблицы - rows

export const zRole = z.object({
  roleId: zUid,
  roleName: z.string(),
});
export type ZRole = z.infer<typeof zRole>;

export const zRolesGroup = z.object({
  groupId: zUid,
  displayGroupId: zDisplayId.nullish(),
  groupName: z.string(),
  roles: zRole.array(),
});
export type ZRolesGroup = z.infer<typeof zRolesGroup>;

// Получение всех возможных действий. Для верхнего заголовка - columns
export enum ActionTypeName {
  object = "OBJECT",
  entity = "ENTITY",
  attribute = "ATTRIBUTE",
}

export enum ActionName {
  create = "CREATE",
  view = "VIEW",
  update = "UPDATE",
  delete = "DELETE",
}

export const zTypeActions = z.object({
  type: z.string(), // ActionTypeName
  actions: zIdName.array(),
});
export type ZTypeActions = z.infer<typeof zTypeActions>;

// Непосредственно редактируемые значения

export const zPermissionRoleItem = z.object({
  roleId: zUid,
  actionIds: zUid.array(),
});
export const zPermissionGroupItem = z.object({
  groupId: zUid,
  roles: zPermissionRoleItem.array(),
});
export type ZPermissionGroupItem = z.infer<typeof zPermissionGroupItem>;
export type ZPermissions = ZPermissionGroupItem[];

export enum PermissionsCopyType {
  attribute = "attribute",
  object = "object",
}
